import { render } from "./ProductsAdmin.vue?vue&type=template&id=a74703f2&scoped=true"
import script from "./ProductsAdmin.vue?vue&type=script&lang=js"
export * from "./ProductsAdmin.vue?vue&type=script&lang=js"

import "./ProductsAdmin.vue?vue&type=style&index=0&id=a74703f2&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a74703f2"]])

export default __exports__